import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "backdrop"];

  toggle() {
    this.panelTarget.classList.contains("is-open") ? this.close() : this.open();
  }

  open() {
    this.panelTarget.classList.add("is-open");
    this.backdropTarget.classList.add("is-visible");
  }

  close() {
    this.panelTarget.classList.remove("is-open");
    this.backdropTarget.classList.remove("is-visible");
  }
}
